var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMacos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2490_147539)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2490_147539",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 16,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6875 1H17.346V19.001H2.6875V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2490_147539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9281 10.5641C14.9074 8.28686 16.7897 7.19269 16.8745 7.13892C15.8155 5.58971 14.169 5.37874 13.5816 5.35392C12.1813 5.2112 10.8472 6.17919 10.1357 6.17919C9.4242 6.17919 8.32797 5.3746 7.16554 5.39735C5.63702 5.4201 4.22846 6.28468 3.44041 7.65394C1.85397 10.4049 3.03501 14.4858 4.58215 16.7217C5.33917 17.8138 6.23892 19.0444 7.42409 18.9989C8.56583 18.9534 8.99605 18.2605 10.3736 18.2605C11.7511 18.2605 12.14 18.9989 13.3438 18.9762C14.5703 18.9514 15.348 17.8593 16.0988 16.763C16.9655 15.4951 17.3233 14.2665 17.344 14.2024C17.3171 14.1921 14.953 13.2861 14.9281 10.5641",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6633 3.87503C13.2921 3.11387 13.7161 2.05487 13.6003 1C12.6943 1.03723 11.5981 1.60396 10.9486 2.36512C10.3674 3.03734 9.85652 4.11496 9.9951 5.14915C11.0024 5.22775 12.0345 4.63412 12.6633 3.87503Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2490_147539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMacos);
export default __webpack_public_path__ + "static/media/ic-macos.514bfa22d56c7d45a3f3bd892900fa1d.svg";
export { ForwardRef as ReactComponent };